import Vuex from 'vuex'
import { ActionContext, MutationTree, ActionTree, GetterTree } from "vuex"
import { ViewState } from './state'
import { RootState } from "../state";
import { Point, SparqlVariable } from '../../model/models'

type Context = ActionContext<ViewState, RootState>;

const state: ViewState = {
  leftPane:'Ontologies',
  updateStatements:false,
  classInstance:true,
  busy:false,
  externalRequest:true,
  errorMessage:'',
  browserName:'',
  language:'en',
  windowSize: new Point(0,0),
  searchResult:[]
};

// mutations are operations that actually mutates the state.
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be rcorded by plugins
// for debugging purposes.
const mutations:MutationTree<ViewState> = {
  leftPane (state, s:string) { state.leftPane = s },
  requestUpdateStatements (state) { state.updateStatements = true },
  doneUpdateStatements (state) { state.updateStatements = false },
  setClassInstance (state, s:boolean) { state.classInstance = s },
  busy (state, s:boolean) { state.busy = s },
  externalRequest (state, s:boolean) { state.externalRequest = s },
  errorMessage (state,s:string) { state.errorMessage = s },
  windowSize (state,s:Point) { state.windowSize = s },
  language (state,s:string) { state.language = s },
  browserName (state,s:string) { state.browserName = s },
  searchResult (state,s:SparqlVariable[]) { state.searchResult = s }
}

// actions are functions that cause side effects and can involve
// asynchronous operations.
const actions:ActionTree<ViewState,any> = {

}
 
// getters are functions
const getters:GetterTree<ViewState,any> = {
  leftPane: (state:ViewState) => { return state.leftPane },
  updateStatements: (state:ViewState) => { return state.updateStatements },
  classInstance: (state:ViewState) => { return state.classInstance },
  busy: (state:ViewState) => { return state.busy },
  externalRequest: (state:ViewState) => { return state.externalRequest },
  errorMessage: (state:ViewState) => { return state.errorMessage },
  windowSize: (state:ViewState) => { return state.windowSize },
  language: (state:ViewState) => { return state.language },
  browserName: (state:ViewState) => { return state.browserName },
  searchResult: (state:ViewState) => { return state.searchResult }
}

// A Vuex instance is created by combining the state, mutations, actions,
// and getters.
export const viewStore = {
  state,
  getters,
  actions,
  mutations
}




// WEBPACK FOOTER //
// ./src/store/view/store.ts